import { HashMap } from "../../shared/model/HashMap";

export const DEFAULT_ENV_NAME = "Default";

export interface EnvironmentState {
    environments: HashMap<Environment> | null;
}

export interface Environment {
    id: number;
    name: string;
    displayName: string;
    displayOrder: number;
}
